import { buildProps, definePropType } from '@ll-plus/utils'

import { TooltipProps } from 'ant-design-vue'
import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type CustomSorter from './custom-sorter.vue'

// 定义组件props
export const customSorterProps = buildProps({
  open: {
    type: Boolean,
    default: false,
  },
  fieldList: {
    type: definePropType<{ key: string; title: string }[]>(Array),
    default: () => [],
  },
  // 最大查询数量
  maxSearchCount: {
    type: Number,
    default: 0,
  },
  // 开启徽标
  useBadge: {
    type: Boolean,
    default: true,
  },
  // 激活状态
  activeState: {
    type: Boolean,
    default: false,
  },
  // 排序图标
  sortIcon: {
    type: String,
  },
  // 升序文本
  ascText: {
    type: String,
  },
  // 降序文本
  descText: {
    type: String,
  },
  // 新增排序文本
  addSortText: {
    type: String,
  },
  // 气泡框位置
  placement: {
    type: definePropType<TooltipProps['placement']>(String),
  },
  label: {
    type: String,
    default: '',
  },
  size: {
    type: definePropType<SizeType | number>([String, Number]),
    default: 'large',
  },
} as const)

// props
export type CustomSorterProps = ExtractPropTypes<typeof customSorterProps>

// instance
export type CustomSorterInstance = InstanceType<typeof CustomSorter>
